function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ResultsOrderComponent from '../../components/Results/ResultsOrder';
import { dataSetOrder } from '../../store/actions/datasetSlice';
function ResultOrder(props) {
  var dispatch = useDispatch();
  var _useSelector = useSelector(function (state) {
      var _state$app, _state$app$project;
      return state === null || state === void 0 ? void 0 : (_state$app = state.app) === null || _state$app === void 0 ? void 0 : (_state$app$project = _state$app.project) === null || _state$app$project === void 0 ? void 0 : _state$app$project.configs;
    }),
    listOrderOptions = _useSelector.listOrderOptions,
    showListOrder = _useSelector.showListOrder;
  var _useSelector2 = useSelector(function (state) {
      var _state$dataset;
      return state === null || state === void 0 ? void 0 : (_state$dataset = state.dataset) === null || _state$dataset === void 0 ? void 0 : _state$dataset.data;
    }),
    order = _useSelector2.orderBy;
  var onChangeOrder = function onChangeOrder(orderBy) {
    dispatch(dataSetOrder({
      orderBy: orderBy
    }));
  };
  return /*#__PURE__*/React.createElement(ResultsOrderComponent, _extends({
    orderOptions: listOrderOptions,
    showListOrder: showListOrder,
    order: order,
    onChangeOrder: onChangeOrder
  }, props));
}
export default ResultOrder;